<script setup lang="ts">
const { slice } = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const items = computed(() => {
  const now = useState<Date>('current-date', () => new Date())

  return slice?.Actions.filter((action) => {
    if (action?.DateFrom && new Date(action.DateFrom) > now.value) {
      return false
    }

    if (action?.DateUntil && new Date(action.DateUntil) < now.value) {
      return false
    }

    return true
  })
})
</script>

<template>
  <StrapiSlice
    class="ct-actions-and-events"
    :slice="slice"
    :index="index"
  >
    <UiCarousel
      v-if="items?.length && slice?.FeedDisplay?.Display === 'Slider'"
      class="ct-actions-and-events__carousel"
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--center': false,
        'ui-carousel--free-scroll': true,
        'ui-carousel--navigation': true,
        'ui-carousel--pagination': false,
        'ui-carousel--progress': false,
      }"
    >
      <template
        v-for="(item, i) in items"
        #[`slide-${i}`]
        :key="item"
      >
        <StrapiActionAndEvent
          :item="item"
          :lazy="index > 0"
          class="ct-actions-and-events__item"
        />
      </template>
    </UiCarousel>
    <div
      v-else-if="items?.length"
      class="ct-actions-and-events__grid"
      :style="`--columns: ${slice?.Actions?.length};`"
    >
      <StrapiActionAndEvent
        v-for="(item) in items"
        :key="item"
        :item="item"
        :lazy="index > 0"
        class="ct-actions-and-events__item"
      />
    </div>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/ActionsAndEvents.css");
</style>
